import React from "react";
import CssClasses from "./TerminalActionButton.css";
import SiteIcons from "../../../assets/fonts/site_icons/style.css";

const TerminalActionButton = props => {
  let classes = [CssClasses.button];

  if (props.isActive) {
    classes.push(CssClasses.active);
  }

  if (props.isLogoutButton) {
    classes.push(CssClasses.logoutBtn);
  }

  let iconName = "";
  let iconClass = "";
  let iconSizeClass = "";
  let colorClass = "";

  if (props.icon === "ticket") {
    iconName = SiteIcons.site_icon_ticket;
    iconClass = CssClasses.iconTicket;
    iconSizeClass = CssClasses.larger;
  } else if (props.icon === "add_money") {
    iconName = SiteIcons.site_icon_add_money;
    iconClass = CssClasses.iconAddMoney;
    iconSizeClass = CssClasses.larger2;
  } else if (props.icon === "location") {
    iconName = SiteIcons.site_icon_location;
    iconClass = CssClasses.iconTerminalLocator;
  } else if (props.icon === "wallet") {
    iconName = SiteIcons.site_icon_wallet;
    iconClass = CssClasses.iconWithdraw;
  } else if (props.icon === "swap") {
    iconName = SiteIcons.site_icon_swap;
    iconClass = CssClasses.iconSwap;
  } else if (props.icon === "aircash") {
    iconName = SiteIcons.site_icon_aircash;
    iconClass = CssClasses.iconAircash;
  } else if (props.icon === "admin_balance") {
    iconName = SiteIcons.site_icon_admin_balance;
    iconClass = CssClasses.iconGeneric;
  } else if (props.icon === "admin_cash_flow") {
    iconName = SiteIcons.site_icon_admin_cash_flow;
    iconClass = CssClasses.iconGeneric;
  } else if (props.icon === "admin_transactions") {
    iconName = SiteIcons.site_icon_admin_transactions;
    iconClass = CssClasses.iconGeneric;
  } else if (props.icon === "admin_tickets") {
    iconName = SiteIcons.site_icon_admin_tickets;
    iconClass = CssClasses.iconGeneric;
  } else if (props.icon === "admin_qr") {
    iconName = SiteIcons.site_icon_admin_qr;
    iconClass = CssClasses.iconGeneric;
  } else if (props.icon === "admin_settings") {
    iconName = SiteIcons.site_icon_admin_settings;
    iconClass = CssClasses.iconGeneric;
  } else if (props.icon === "admin_logout") {
    iconName = SiteIcons.site_icon_admin_logout;
    iconClass = CssClasses.iconGeneric;
  } else if (props.icon === "admin_log") {
    iconName = SiteIcons.site_icon_admin_log;
    iconClass = CssClasses.iconGeneric;
  } else if (props.icon === "admin_search") {
    iconName = SiteIcons.site_icon_admin_search;
    iconClass = CssClasses.iconGeneric;
  } else if (props.icon === "admin_dashboard") {
    iconName = SiteIcons.site_icon_admin_dashboard;
    iconClass = CssClasses.iconGeneric;
  } else if (props.icon === "admin_invoice") {
    iconName = SiteIcons.site_icon_admin_invoice;
    iconClass = CssClasses.iconGeneric;
  } else if (props.icon === "chalice") {
    iconName = SiteIcons.site_icon_chalice;
    iconClass = CssClasses.iconWithdraw;
  } else if (props.icon === "plus") {
    iconName = SiteIcons.site_icon_plus;
    iconClass = CssClasses.iconWithdraw;
  }

  if (props.color === "yellow") {
    colorClass = CssClasses.yellow;
  }

  var iconClasses = [
    iconName,
    iconClass,
    CssClasses.legendIcon,
    iconSizeClass,
    colorClass
  ];
  var arrowClasses = [
    SiteIcons.site_icon_arrow,
    CssClasses.iconArrow,
    CssClasses.legendIcon
  ];

  return (
    <div
      onClick={() => {
        props.onButtonClicked(props.id);
      }}
      className={classes.join(" ")}
    >
      <span className={iconClasses.join(" ")} />
      <span className={CssClasses.text}>{props.title}</span>
      <span className={arrowClasses.join(" ")} />
    </div>
  );
};

export default TerminalActionButton;



// WEBPACK FOOTER //
// ./src/Components/UI/TerminalActionButton/TerminalActionButton.js